import { Form } from "react-bootstrap";
import styles from "./Search.module.css";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import FiltersMenu, { IFilters } from "./elements/FiltersMenu/FiltersMenu";

interface ISearch {
  isExploreMode: boolean;
  selectedFilters(filters: IFilters): void;
}

const Search: React.FC<ISearch> = (props) => {
  const [searchPhrase, setSearchPhrase] = useState("");
  const isMobile = useSelector((state: RootState) => state.client.isMobile);
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isFiltersMenuVisible, setIsFiltersMenuVisible] = useState(false);
  const [filters, setFilters] = useState<IFilters>({
    minPublicationDateTime: null,
    maxPublicationDateTime: null,
    minPreparationTime: null,
    maxPreparationTime: null,
    isPublic: null,
    isFromExplore: null,
    languageId: null,
    tags: null,
    searchQuery: null,
  });

  const onFilterIconClick = () => {
    setIsFiltersMenuVisible(!isFiltersMenuVisible);
  };

  const onFiltersSelected = (filtersFromFiltersMenu: IFilters) => {
    setFilters({ ...filtersFromFiltersMenu, searchQuery: searchPhrase });
  };

  const onSearchQuery = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchPhrase(e.target.value);
    setFilters({ ...filters, searchQuery: e.target.value });
  };

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  useEffect(() => {
    props.selectedFilters(filters);
  }, [filters]);

  return (
    <div className={isMobile ? styles.containerMobile : styles.containerDesktop}>
      <Form.Group controlId="search" className={`${styles.autoFillIconContainer} mt-3 mb-1`}>
        <Form.Control
          type="text"
          name="search"
          placeholder={t("components.feature.search.searchField")}
          ref={inputRef}
          value={searchPhrase}
          onChange={onSearchQuery}
        />
        <div className={styles.autoFillIcon} onClick={() => onFilterIconClick()}>
          <i className="bi bi-funnel"></i>
        </div>
      </Form.Group>
      <FiltersMenu
        selectedFilters={onFiltersSelected}
        visible={isFiltersMenuVisible}
        isExploreMode={props.isExploreMode}
      />
    </div>
  );
};

export default Search;
